
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import {
  Pagination,
  Input,
  Form,
  Modal,
  Button,
  Radio,
  DatePicker,
  Select,
  Table,
  Tooltip,
} from 'ant-design-vue';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';

import CheckboxForClass from '@/components/CheckboxForClass.vue';
import myButton from '@/components/Button.vue';
import myModal from '@/components/Modal.vue';
// import myFormModal from '@/components/myFormModal.vue';
import asynButtonVue from '@/components/asynButton.vue';
import customCaseModuleFun from './js/customCaseModule';
import experimentModuleFun from './js/experimentModule';
import controllerModuleFun from './js/controllerModule';
import '@/assets/icons/back.svg';
import '@/assets/icons/question.svg';

const component = defineComponent({
  name: 'teacher-experiment',
  components: {
    ManagementFrame,
    SvgIcon,
    myModal,
    // myFormModal,
    myButton,
    CheckboxForClass,
    aPagination: Pagination,
    aInput: Input,
    aForm: Form,
    aFormItem: Form.Item,
    aModal: Modal,
    aButton: asynButtonVue,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
    aRangePicker: DatePicker.RangePicker,
    aSelect: Select,
    aSelectOption: Select.Option,
    aTable: Table,
    aTooltip: Tooltip,
  },
  setup() {
    const router = useRouter();
    const customCaseModule = customCaseModuleFun();
    const experimentModule = experimentModuleFun();
    const controllerModule = controllerModuleFun(router);

    return {
      controllerModule,
      customCaseModule,
      experimentModule,
    };
  },
});

export default component;
